import React from "react"
import Residential from "../../components/pages/development/residential"

const ResidentialPage = (props) => <Residential {...props} />

export default ResidentialPage